import { Palmtree, ArrowLeftRight, Receipt, Clock, UserSearch, GraduationCap, Rocket, ClipboardList, IdCard, Heart, Briefcase, FileSignature } from 'lucide-react';

import { PENDING_APPROVAL_MODE } from '../../ats-requisitions/requisitionActions';
import { PENDING_APPROVAL_MODE as OFFER_PENDING_APPROVAL_MODE } from '../../ats-offers/offerPendingMode';

// Onay kategorilerinin TEK meta veri kaynağı. Sunucu yalnız {key, count}
// döndürür; etiket, ikon, rota ve sıra burada durur.
//
// SIRA SABİTTİR ve sayıya göre yeniden dizilmez — panel her açıldığında kart
// aynı yerde durmalı ki kas hafızası kurulabilsin.
//
// İkonlar MenuConfig.js'te bu modüller için zaten kullanılan lucide
// ikonlarıdır; panel ile menü aynı görsel dili konuşsun diye.
export const APPROVAL_CATEGORIES = [
  { key: 'leave',     labelKey: 'menu.pendingApprovals',            icon: Palmtree,       path: '/pending-approvals',            module: 'LM', privileges: [] },
  { key: 'shiftSwap', labelKey: 'menu.shiftSwapApprovals',          icon: ArrowLeftRight, path: '/shift-swap-approvals',         module: 'SM', privileges: [] },
  { key: 'expense',   labelKey: 'menu.expensePending',              icon: Receipt,        path: '/expense-pending-approvals',    module: 'EX', privileges: [] },
  { key: 'overtime',  labelKey: 'menu.overtimeApprovals',           icon: Clock,          path: '/overtime-approvals',           module: 'TA', privileges: ['TA.Read'] },
  { key: 'visit',     labelKey: 'menu.visitApprovals',              icon: UserSearch,     path: '/visit-approvals',              module: 'VM', privileges: [] },
  { key: 'training',  labelKey: 'menu.trainingPendingApprovals',    icon: GraduationCap,  path: '/training-pending-approvals',   module: 'TR', privileges: ['TR.Read'] },
  // OB-B (Faz 3) — yetki listesi BİLEREK boş, kardeş `obTask` ile aynı desen.
  // Kuyruğun sahibi imzalaması beklenen YÖNETİCİDİR ve onda kiracı geneli
  // OB.Read YOKTUR (olsaydı her yeni çalışanın deneme süresi değerlendirme
  // notunu okurdu). Sunucu da aynı kapıyı uygular: ApprovalSummaryDataAccess
  // yalnız modül kapısına bakar, sayının kendisi ilişkiye göre kapsanır.
  { key: 'obPeriod',  labelKey: 'menu.onboardingPeriodApprovals',   icon: Rocket,         path: '/onboarding/period-approvals',  module: 'OB', privileges: [] },
  // İşe alıştırma GÖREV onayları. Yetki listesi BİLEREK boş: kuyruğun sahibi
  // sürecin yöneticisidir ve yöneticide tenant geneli OB.Read YOKTUR (kart,
  // ilişki kapsamlı "Ekibimin İşe Alıştırması" paneline götürür). Sunucu da
  // aynı kapıyı uygular (ApprovalSummaryDataAccess: yalnız modül kapısı).
  { key: 'obTask',    labelKey: 'menu.onboardingTaskApprovals',     icon: ClipboardList,  path: '/my-team-onboarding',           module: 'OB', privileges: [] },
  { key: 'resume',    labelKey: 'menu.resumePending',               icon: IdCard,         path: '/resume-pending',               module: null, privileges: ['EM.Write'] },
  { key: 'benefit',   labelKey: 'menu.benefitApprovals',            icon: Heart,          path: '/benefit-applications?mode=pending', module: 'BN', privileges: ['BN.Write'] },
  // ATS kadro talebi onayları (FE-13). Sunucu kapısı AtsRequisitionController
  // ile aynı: AT modülü + AT.Read (AT VARSAYILAN modül değildir, kapı gerçekten
  // kapanır). Derin bağlantı `mode=pendingApproval` sayfada `pendingForMe=true`
  // sorgusuna çevrilir — kartın saydığı yüklemin AYNISI, yani kart ile liste
  // ayrışamaz. Sıra SABİT: yeni kategori SONA eklenir, mevcut kartların yeri
  // değişmez (kas hafızası).
  { key: 'atsRequisition', labelKey: 'menu.atsRequisitionApprovals', icon: Briefcase, path: `/ats/requisitions?mode=${PENDING_APPROVAL_MODE}`, module: 'AT', privileges: ['AT.Read'] },
  // ATS TEKLİF onayları. Kadro talebiyle AYNI kapı (AT + AT.Read) ama AYRI kart:
  // ikisi farklı kararlardır (kadro açılsın mı / bu adaya bu koşullarla teklif
  // verilsin mi), farklı kişilere düşebilir ve farklı ekranlara götürür. Tek sayıda
  // toplamak onaycıyı yanlış listeye indirirdi. Derin bağlantı yine
  // `mode=pendingApproval` → sunucuda `pendingForMe=true`.
  { key: 'atsOffer', labelKey: 'menu.atsOfferApprovals', icon: FileSignature, path: `/ats/offers?mode=${OFFER_PENDING_APPROVAL_MODE}`, module: 'AT', privileges: ['AT.Read'] },
];

// Sol menüdeki "Onaylarım" öğesi, kullanıcının HİÇBİR onay kategorisi yoksa
// çizilmez. Karar ağ isteği beklemeden verilir: sunucu yanıtını beklemek ya
// öğeyi gösterip sonra kaldırmak (titreme) ya da geç göstermek (menü sonradan
// belirir) demekti. Sayılarda otorite yine sunucudur; bu yalnız görünürlük.
export function hasAnyApprovalCategory({ hasModule, canRead, canWrite, isSuperAdmin }) {
  if (isSuperAdmin) return true;

  return APPROVAL_CATEGORIES.some((c) => {
    if (c.module && !hasModule(c.module)) return false;
    return c.privileges.every((p) => {
      const [code, level] = p.split('.');
      return level === 'Write' ? canWrite(code) : canRead(code);
    });
  });
}
